import * as user from './user';
import * as featuredEvent from './featuredEvent';

export default {
  ...user,
  ...featuredEvent,
};
